"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmInputToken = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
const SmInputToken = (_a) => {
    var { disabled = false, min = 0, max = 6, state, maxLength = 1, inputMode = 'numeric', type = 'number', length = 4, label = 'token', labelIcon, value, message, onChange, srOnly } = _a, props = __rest(_a, ["disabled", "min", "max", "state", "maxLength", "inputMode", "type", "length", "label", "labelIcon", "value", "message", "onChange", "srOnly"]);
    const initializeValue = () => {
        if (value) {
            return value
                .split('')
                .reduce((array, currentvalue, index) => (Object.assign(Object.assign({}, array), { [index]: currentvalue })), {});
        }
        return Array(length)
            .fill('')
            .reduce((array, currentvalue, index) => (Object.assign(Object.assign({}, array), { [index]: currentvalue })), {});
    };
    const [auxValue, setAuxValue] = react_1.default.useState(initializeValue);
    const inputClassname = (0, classnames_1.default)(`-${state}`);
    const listitemRef = react_1.default.useRef([]);
    const iconMap = {
        error: (react_1.default.createElement(Icon_1.SmIcon, { type: "outlined", name: "error_outline", size: "small", "data-testid": "test-error-icon" })),
        success: (react_1.default.createElement(Icon_1.SmIcon, { type: "outlined", name: "check_circle", size: "small", "data-testid": "test-success-icon" })),
        default: (react_1.default.createElement(Icon_1.SmIcon, { type: "outlined", name: "info", size: "small", "data-testid": "test-success-icon" })),
    };
    react_1.default.useMemo(() => {
        if (value === undefined || value === '') {
            setAuxValue({});
            return;
        }
        if (!Number.isNaN(parseInt(value, 10))) {
            const updatedValue = value
                .split('')
                .reduce((array, currentvalue, index) => (Object.assign(Object.assign({}, array), { [index]: currentvalue })), {});
            setAuxValue(updatedValue);
        }
    }, [value]);
    const inputs = react_1.default.useMemo(() => {
        return Array.from(Array(length), (_, i) => {
            return (react_1.default.createElement("input", Object.assign({ key: i, type: type, inputMode: inputMode, min: min, max: max, maxLength: maxLength, disabled: disabled, ref: (el) => {
                    listitemRef.current[i] = el;
                }, className: inputClassname, "aria-label": `${label}, ${i + 1} de ${length}`, value: auxValue[i] || '', onChange: (e) => {
                    var _a;
                    const nativeEvent = e.nativeEvent;
                    if (auxValue[i] === undefined ||
                        auxValue[i].length < 1 ||
                        nativeEvent.data === null) {
                        const updatedValue = Object.assign(Object.assign({}, auxValue), { [i]: e.target.value });
                        setAuxValue(updatedValue);
                        onChange === null || onChange === void 0 ? void 0 : onChange(Object.values(updatedValue).join(''), e);
                        if (e.target.value) {
                            const nextInput = (_a = listitemRef.current[i]) === null || _a === void 0 ? void 0 : _a.nextSibling;
                            if (length !== i + 1) {
                                nextInput.focus();
                            }
                        }
                    }
                } }, props)));
        });
    }, [
        auxValue,
        inputClassname,
        type,
        inputMode,
        min,
        max,
        maxLength,
        disabled,
        value,
        length,
    ]);
    const fieldClassnames = (0, classnames_1.default)('c-field', `-${state}`, {
        '-disabled': disabled,
    });
    const fieldLabelClassName = (0, classnames_1.default)('c-field__label', {
        '-hidden': srOnly,
    });
    return (react_1.default.createElement("div", { className: fieldClassnames },
        react_1.default.createElement("label", { className: fieldLabelClassName, htmlFor: label },
            label,
            labelIcon && react_1.default.createElement(Icon_1.SmIcon, { name: labelIcon, type: "outlined", size: "small" })),
        react_1.default.createElement("div", { className: `c-token -${state}` }, inputs),
        message && (react_1.default.createElement("small", { id: `${label}-description`, className: "c-field__description", "data-testid": "test-icon-container" },
            iconMap[state],
            message))));
};
exports.SmInputToken = SmInputToken;
//# sourceMappingURL=index.js.map